import patientService from '@/services/patientService';
import psychologistConsultationService from '@/services/psychologistConsultationService';
import questionnariesService from '@/services/questionnariesService';
import { errorHttpMessage } from "@/utils/errorDecodeUtil";

export const getPatientById = async ({ commit }, { user_id, consultation_id = null }) => {
  try {
    const { data: response } = await patientService.getPatientById(user_id, consultation_id);
    return response.result;
  } catch (ex) {
    // const error_http_message = errorHttpMessage(ex);
    return {
      // message: error_http_message?.message,
      // error_keys: error_http_message?.error_keys,
      // data: ex?.response?.data,
      error: true,
    };
  }
}

export const setPsychologyEvaluation = async ({ commit }, info) => {
  try {
    const { data: response } = await psychologistConsultationService.setPsychologyEvaluation(info);
    return response.result;
  } catch (ex) {
    // const error_http_message = errorHttpMessage(ex);
    return {
      // message: error_http_message?.message,
      // error_keys: error_http_message?.error_keys,
      // data: ex?.response?.data,
      error: true,
    };
  }
}

export const getPsychologyEvaluation = async ({ commit }, info) => {
  try {
    const { data: response } = await psychologistConsultationService.getPsychologyEvaluation(info.psychology_consultation_id);
    return response.result;
  } catch (ex) {
    // const error_http_message = errorHttpMessage(ex);
    return {
      // message: error_http_message?.message,
      // error_keys: error_http_message?.error_keys,
      // data: ex?.response?.data,
      error: true,
    };
  }
}

export const updateSessionType = async ({ commit }, data) => {
  try {
    const { data: response } = await patientService.updateSessionType(data);
    return response;
  } catch (ex) {
    const error_http_message = errorHttpMessage(ex);
    return {
      message: error_http_message?.message,
      error_keys: error_http_message?.error_keys,
      data: ex?.response?.data,
      error: true,
    };
  }
}

export const getPHQ9Result = async ({ commit }, { patient_id }) => {
  try {
    const { data: response } = await questionnariesService.getPHQ9Result(patient_id);
    return response.result;
  } catch (ex) {
    return {
      error: true,
    };
  }
}

export const getGAD7Result = async ({ commit }, { patient_id }) => {
  try {
    const { data: response } = await questionnariesService.getGAD7Result(patient_id);
    return response.result;
  } catch (ex) {
    return {
      error: true,
    };
  }
}

export const getProQOLResult = async ({ commit }, { patient_id }) => {
  try {
    const { data: response } = await questionnariesService.getProQOLResult(patient_id);
    return response.result;
  } catch (ex) {
    return {
      error: true,
    };
  }
}

export const getCommunicationChannels = async ({ commit }) => {
  try {
    const { data: response } = await psychologistConsultationService.getCommunicationChannels();
    return response.result;
  } catch (ex) {
    const error_http_message = errorHttpMessage(ex);
    return {
      message: error_http_message?.message,
      error_keys: error_http_message?.error_keys,
      data: ex?.response?.data,
      error: true,
    };
  }
}

export const updatePatientAttendance = async ({ commit }, { consultationId, attendanceData }) => {
  try {
    const { data: response } = await psychologistConsultationService.updatePatientAttendance(consultationId, attendanceData);
    return response.result;
  } catch (ex) {
    const error_http_message = errorHttpMessage(ex);
    return {
      message: error_http_message?.message,
      error_keys: error_http_message?.error_keys,
      data: ex?.response?.data,
      error: true,
    };
  }
}

export const updateReferralConsultation = async ({ commit }, { consultationId, referralData }) => {
  try {
    const { data: response } = await psychologistConsultationService.updateReferralConsultation(consultationId, referralData);
    return response.result;
  } catch (ex) {
    const error_http_message = errorHttpMessage(ex);
    return {
      message: error_http_message?.message,
      error_keys: error_http_message?.error_keys,
      data: ex?.response?.data,
      error: true,
    };
  }
}